import React, { useContext } from "react";
import Status from "./Status";
import ActionsContext from "common/ActionsContext";
import { requestFactsAndMoment, reconnect } from "./api";
import BusyWarningModal from "./BusyWarning";
import ConfigBilling from "views/Config/BillingView/component";
import BqnContext from "common/BqnContext";
import View from "common/View";
import help from "help/viewStatusBilling.md";

const BillingStatus = ({returnView = null}) => {
  const actions = useContext(ActionsContext);
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const mode = clusterStatus?.mode;
  const mayWarnBusy = () => actions.send("show-busy-warning");
  const doReconnect = () => reconnect(mayWarnBusy, mode, bqnId);
  return (
    <>
      <ConfigBilling returnView={returnView} />
      <View
        title="Billing Connector Status"
        mdHelp={help}
        helpSignal="open-help-connector-status"
        returnView={returnView}
        className="container-lg"
        frameClassName="no-min-height"
        refresh={() => actions.send("do-load-billing-status")}
      >
        <div className="body flex-panel-column padding-20">
          <Status
            provider={() => requestFactsAndMoment(mode, bqnId)}
            reconnect={doReconnect}
            bqnId={bqnId}
          />
        </div>
        <BusyWarningModal />
      </View>
    </>
  );
};

export default BillingStatus;
